export const useColors = () => ({
    greenCS: '#0E773C',
    greenLight: '#00b95a',
    blueCS: '#17194B',
    blueLight: '#84cdf5',
    yellowCS: '#FFE600',
    redCS: '#E7141C',
    redDarkCS: '#A61E17',
    grayDarkCS: '#1D1D1D',
    white: '#fff',
    redLight: '#d36e6e',
    red: '#d9534f',
    gray: '#ddd',
    grayLight: '#f7f7f7',
    grayDark: '#666',
    green: '#0cff00',
    yellow: '#fff600',
    orange: '#ff7b00',

});
